import { ActionButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { AddressModel } from "../../models/AddressModel";
import { useCustomerAddressVM } from "../../viewmodels/CustomerAddressVM";
import { useStateVM } from "../../viewmodels/StateVM";
import AddressEntryView from "./AddressEntryView";
import AddressGridView from "./AddressGridView";

export type CustomerAddressProps = {
    onSelect?: (address: AddressModel) => void;
}

export default function CustomerAddressView({ onSelect }: CustomerAddressProps) {
    const hasLoaded = useRef(false);
    const vm = useCustomerAddressVM();
    const stateVM = useStateVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        stateVM.getList();
        vm.getList();
    }, [vm, stateVM]);

    const onDelete = (address: AddressModel) => {
        if (window.confirm(`Are you sure to delete the address?`)) {
            vm.del(address.id);
        }
    }

    const onClose = () => {
        vm.setIsEdit(false);
        vm.setShowEntry(false);
        vm.resetForm();
    }

    const onSubmit = () => {
        if (vm.isEdit) {
            vm.edit();
        } else {
            vm.create();
        }
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => vm.setShowEntry(true)}
            >Add New</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 pv-10 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Addresses</div>
            {addButton()}
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <AddressGridView
                    addresses={vm.addresses}
                    key={vm.listHash}
                    onEdit={(address: AddressModel) => {
                        vm.setForm(address);
                        vm.setIsEdit(true);
                        vm.setShowEntry(true);
                    }}
                    onDelete={onDelete}
                    onSelect={onSelect}
                />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {vm.showEntry && <>
            <AddressEntryView
                isEdit={vm.isEdit}
                form={vm.form}
                errorMessages={vm.errorMessages}
                states={stateVM.options}
                submitting={vm.submitting}
                onValueChange={vm.setField}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        </>}
    </>;
}